module.exports = __webpack_public_path__ + "static/media/iconDefuncion02.96fa62b3.svg";